//-tech-debt-react-query;
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { CacheKey } from "../../../types/cache-keys";
import { ModelConfig, normalizeEndpoint } from "../RbacConfig";
import { fetchItems } from "../../../support/queries";

const useModelQuery = (model: ModelConfig, enabled = true): UseQueryResult<any, unknown> => {
  const { url, params: modelParams } = normalizeEndpoint(model.endpoint);
  const params: Record<string, any> = { ...(modelParams || {}) };
  return useQuery({
    queryKey: [CacheKey.Admin, model.key, params],
    queryFn: async () => {
      const data = await fetchItems(url, params);
      return data;
    },
    enabled: model.key !== 'ai' && enabled,
  });
}

export default useModelQuery;